export function fetchingTrips(state, promise) {
  state.tripsLoading = true;
  state.tripsPromise = promise;
}

export function setTrips(state, trips) {
  state.trips = Object.freeze({ ...trips });
}

export function tripsFetched(state) {
  state.tripsLoading = false;
  state.tripsPromise = null;
}

export function selectTrip(state, tripKey) {
  state.selectedTripKey = tripKey;
}

export function clearTrips(state) {
  state.trips = [];
}

export function setPoints(state, tripKey, points) {
  state.points = Object.freeze({ ...state.points }, { [tripKey]: points });
}

export function setSelectedVehicleTrip(state, tripData) {
  state.selectedVehicleTrip = Object.freeze({ ...tripData });
}

export function setViewedVehicleTripKey(state, tripKey) {
  state.viewedVehicleTripKey = tripKey;
}

export function setViewedVehicleTrip(state, trip) {
  state.viewedVehicleTrip = Object.freeze({ ...trip });
}
